function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
export const FileMinusIcon = /*#__PURE__*/forwardRef(({
  className,
  style,
  ariaLabel,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  ref: ref,
  className: className,
  "aria-label": ariaLabel || "file, document, file minus, plus, file remove, remove",
  style: style,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.5 18.5L4.5 18.5C3.94772 18.5 3.5 18.0523 3.5 17.5L3.5 2.5C3.5 1.94772 3.94772 1.5 4.5 1.5L10 1.5L11.5858 1.5C11.851 1.5 12.1054 1.60536 12.2929 1.79289L16.2071 5.70711C16.3946 5.89464 16.5 6.149 16.5 6.41421L16.5 10L16.5 17.5C16.5 18.0523 16.0523 18.5 15.5 18.5Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 10.5L7.5 10.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default FileMinusIcon;